import React, { use, useEffect, useState } from "react";
import "../styles/style.css";
import "../styles/Register.css";
import bhrigu from "../assets/images/bhrigu.png";
import lineage from "../assets/images/lineage.png";
import lineage2 from "../assets/images/lineage2.png";
import lineage3 from "../assets/images/lineage3.png";
import lineage4 from "../assets/images/lineage4.png";
import lineage5 from "../assets/images/lineage5.png";
import lineage6 from "../assets/images/lineage6.png";
import { useNavigate } from "react-router-dom";
import config from "../services/config";
import { showAlert } from "../utilities/alertService";
import Loader from "../utilities/Loader";
import bhrigu_logo from "../assets/images/bhrigu-logo.gif";

const marital_statusOptions = [
  { value: "single", label: "Single" },
  { value: "married", label: "Married" },
  { value: "divorced", label: "Divorced" },
  { value: "widowed", label: "Widowed" },
];

const gender_options = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "other", label: "Other" },
];

const RegisterPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    gender: "",
    father_name: "",
    dob: "",
    marital_status: "",
    address_line_1: "",
    address_line_2: "",
    country: { PK: 26, country: "India" }, // will hold { PK, country }
    state: "",
    pincode: "",
    mobile: "",
    email: "",
    aadhaar_no: "",
    gotra: "",
    kuldevi: "",
  });
  const [errors, setErrors] = useState({});
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [registeredMembers, setRegisteredMembers] = useState(0);
  const [visitorCount, setVisitorCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [gotraKuldeviErrorCount, setGotraKuldeviErrorCount] = useState(0); // Track errors
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpData, setOtpData] = useState("");
  const [otpError, setOtpError] = useState("");
  const [aadharData, setAadharData] = useState();

  const getCountryList = async () => {
    try {
      setLoading(true);
      const response = await config.getCountryList("");
      console.log("country List:", response);
      if (response.status === 200) {
        setCountryList(response.data);
      } else {
        showAlert("error", response.message || "Failed to fetch country list");
      }
    } catch (error) {
      console.error("Error fetching country list:", error);
    } finally {
      setLoading(false);
    }
  };

  const getStateList = async () => {
    try {
      if (formData.country?.PK !== 26) return; // Only fetch for India
      const payload = { country: formData.country.PK };
      const response = await config.getStateList(payload);
      if (response.status === 200) {
        setStateList(response.data);
      } else {
        showAlert("error", response.message || "Failed to fetch State list");
      }
    } catch (error) {
      console.error("Error fetching state list:", error);
    }
  };

  const getRegisteredMember = async () => {
    try {
      const response = await config.customerCount("");
      console.log("Registered Members API Response:", response);

      setRegisteredMembers(response?.customers ?? 0);
    } catch (error) {
      console.error("Error fetching registered members:", error);
      setRegisteredMembers(0);
    }
  };

  const getVisiterCount = async () => {
    try {
      const response = await config.getRegisterVisit();
      console.log("Visitor Count API Response:", response);

      setVisitorCount(response?.count ?? 0);
    } catch (error) {
      console.error("Error fetching visitor count:", error);
      setVisitorCount(0);
    }
  };

  // const sendAadharOTP = async () => {
  //   try {

  //     setLoading(true);
  //     const payload = { aadhaar_no: formData.aadhaar_no };
  //     const response = await config.aadhaarSendOtp(payload);
  //     console.log("otpData", response);
  //     if (response.success === true && response?.data?.data.message === "OTP sent successfully") {
  //       setOtpData(response.data);
  //       showAlert("success", response?.data?.data.message || "OTP sent successfully");
  //     }
  //     else {
  //       showAlert("error", response?.data?.data.message || "Failed to send OTP");
  //     }
  //     if (response.success === false) {  // added else if to handle case when success is false
  //       showAlert("error", response?.message || "Failed to send OTP");
  //     }
  //   } catch (error) {
  //     console.error("Error sending OTP:", error);
  //   }
  //   finally {
  //     setLoading(false);
  //   }
  // };

  const formatDob = (dob) => {
    if (!dob) return "";
    const parts = dob.split("-");
    if (parts.length !== 3) return dob;
    // detect if input is yyyy-mm-dd
    if (parts[0].length === 4) {
      // yyyy-mm-dd → dd-mm-yyyy
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    // assume already dd-mm-yyyy
    return `${parts[0]}-${parts[1]}-${parts[2]}`;
  };

  // const veryfyAadharOTP = async () => {
  //   try {

  //     setLoading(true);
  //     const payload = {
  //       aadhaar_no: formData.aadhaar_no,
  //       reference_id: String(otpData?.data?.reference_id || ""),
  //       otp: otp
  //     };

  //     const response = await config.aadharVerifyOtp(payload);
  //     console.log("otpData", response);

  //     // ✅ actual Aadhaar details
  //     const apiData = response?.data?.data;

  //     if (response.success === true && apiData) {
  //       // ✅ Save Aadhaar data in state
  //       setAadharData(apiData);

  //       // ✅ Compare Name & DOB
  //       const nameMatch =
  //         formData.name.trim().toLowerCase() === apiData.name.trim().toLowerCase();
  //       const dobMatch = (() => {
  //         const formDobFormatted = formatDob(formData.dob.trim());
  //         const apiDobFormatted = formatDob(apiData.date_of_birth.trim());
  //         return formDobFormatted === apiDobFormatted;
  //       })();
  //       if (nameMatch && dobMatch) {
  //         setOtpVerified(true);
  //         showAlert(
  //           "success",
  //           response.message || "OTP verified successfully & data matched"
  //         );
  //       } else {
  //         showAlert(
  //           "error",
  //           "OTP verified but entered Name/DOB does not match Aadhaar records"
  //         );
  //       }
  //     } else {
  //       showAlert("error", response.message || "Failed to verify OTP");
  //     }
  //   } catch (error) {
  //     console.error("Error verifying OTP:", error);
  //     showAlert("error", "Something went wrong while verifying OTP");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    getCountryList();
    getRegisteredMember();
    getVisiterCount();
  }, []);

  useEffect(() => {
    if (formData.country) {
      getStateList();
    }
  }, [formData.country]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Validation function
  const validate = () => {
    let newErrors = {};

    if (!formData.name?.trim()) newErrors.name = "Full Name is required";
    if (!formData.gender?.trim()) newErrors.gender = "Gender is required";
    if (!formData.father_name?.trim())
      newErrors.father_name = "Father's Name is required";
    if (!formData.dob) newErrors.dob = "Date of Birth is required";
    if (!formData.mobile?.trim()) {
      newErrors.mobile = "Mobile number is required";
    } else if (!/^[6-9]\d{9}$/.test(formData.mobile)) {
      newErrors.mobile = "Enter a valid 10-digit mobile number";
    }
    if (!formData.email?.trim()) {
      newErrors.email = "Email is required";
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)
    ) {
      newErrors.email = "Enter a valid email address";
    }
    // if (!formData.aadhaar_no?.trim()) {
    //   newErrors.aadhaar_no = "Aadhar number is required";
    // } else if (!/^\d{12}$/.test(formData.aadhaar_no)) {
    //   newErrors.aadhaar_no = "Enter a valid 12-digit Aadhar number";
    // }
    if (formData.country?.PK === 26) {
      if (!formData.aadhaar_no) {
        newErrors.aadhaar_no = "Aadhaar number is required";
      } else if (!/^\d{12}$/.test(formData.aadhaar_no)) {
        newErrors.aadhaar_no = "Enter valid 12-digit Aadhaar number";
      }
    }
    if (!formData.state?.trim()) newErrors.state = "State is required";
    if (!formData.country) newErrors.country = "Country is required";
    if (!formData.pincode?.trim()) {
      newErrors.pincode = "Pincode is required";
    } else if (!/^\d{6}$/.test(formData.pincode)) {
      newErrors.pincode = "Enter a valid 6-digit pincode";
    }
    if (!formData.marital_status?.trim())
      newErrors.maritalStatus = "Marital Status is required";
    if (!formData.address_line_1?.trim())
      newErrors.address_line_1 = "Address Line 1 is required";
    if (!formData.gotra?.trim()) newErrors.gotra = "Gotra is required";
    if (!formData.kuldevi?.trim()) newErrors.kuldevi = "Kuldevi is required";
    return newErrors;
  };

  const handleSendOtp = async () => {

    let newErrors = {};

    // ✅ Name
    if (!formData.name?.trim()) newErrors.name = "Full Name is required";

    // ✅ DOB
    if (!formData.dob?.trim()) newErrors.dob = "Date of Birth is required";

    // ✅ Aadhaar
    if (!formData.aadhaar_no?.trim()) {
      newErrors.aadhaar_no = "Aadhaar Number is required";
    } else if (!/^\d{12}$/.test(formData.aadhaar_no)) {
      newErrors.aadhaar_no = "Enter a valid 12-digit Aadhaar number";
    }

    // ❌ If errors → show them below fields
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors); // <-- use your state hook for errors
      return;
    }

    // ✅ No errors → clear previous errors, send OTP
    setErrors({});
    setOtpSent(true);
    // await sendAadharOTP();
  };

  const handleVerifyOtp = async () => {
    // await veryfyAadharOTP();
  };

  // Handle form submission
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   const validationErrors = validate();
  //   setErrors(validationErrors);
  //   if (Object.keys(validationErrors).length === 0) {
  //     try {
  //       setLoading(true);
  //       const payload = {
  //         ...formData,
  //         country: formData.country?.PK, // send PK to backend
  //         state: formData.state,
  //       };
  //       const response = await config.createEnquiry(payload);
  //       if (response.status === 200) {
  //         showAlert(
  //           "success",
  //           response.message +
  //             ". Your Reg No is " +
  //             response.registration_no +
  //             ". Approval required, watch your inbox.",
  //           () => navigate("/")
  //         );
  //       } else if (response.status === 404) {
  //         showAlert("error", response.message || "Registration failed");
  //       } else if (response.status === 409) {
  //         showAlert("error", response.message || "Email already registered");
  //       } else {
  //         showAlert("error", "Something went wrong. Please try again.");
  //       }
  //     } catch (error) {
  //       console.error("Error creating enquiry:", error);
  //       showAlert("error", "An unexpected error occurred. Please try again.");
  //     }finally {
  //     setLoading(false); // hide loader no matter what
  //   }
  //   }
  // };

  const handleSubmit = async (e) => {

    e.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      try {
        setLoading(true);

        const payload = {
          ...formData,
          country: formData.country?.country, // send PK to backend
          state: formData.state,
        };

        const response = await config.createEnquiry(payload);

        if (response.status === 200) {
          // reset error count on success
          setGotraKuldeviErrorCount(0);

          showAlert(
            "success",
            response.message +
            ". Your Reg No is " +
            response.registration_no +
            ". Approval required, watch your inbox.",
            () => navigate("/")
          );
        } else if (response.status === 404) {
          // Increment error count on 404
          setGotraKuldeviErrorCount((prev) => {
            const newCount = prev + 1;

            if (newCount % 3 === 0) {
              // Every 3rd attempt — friendly message + reset counter
              showAlert(
                "error",
                "It looks like you're having trouble with the form.\n\nPlease connect with the Web Admin below if you need help.\n\n📞 +91-9810420015\n📧 bhrigulineage@gmail.com"
              );
              return 0; // reset count after showing help message
            }

            // Otherwise, show standard invalid message
            showAlert(
              "error",
              response.message || `Invalid Gotra or Kuldevi (Attempt ${newCount}/3 before help message).`
            );

            return newCount;
          });
        } else if (response.status === 409) {
          showAlert("error", response.message || "Email already registered");
        } else {
          showAlert("error", "Something went wrong. Please try again.");
        }
      } catch (error) {
        console.error("Error creating enquiry:", error);
        showAlert("error", "An unexpected error occurred. Please try again.");
      } finally {
        setLoading(false); // hide loader no matter what
      }
    }
  };

  return (
    <div className="registerpage">
      <div className="container justifycentercontainer">
        <div className="row responsive">
          {/* Left Logo + Slider */}
          <div
            className="col-md-4"
            onClick={() => navigate("/")}
            style={{ cursor: "pointer" }}
          >
            <div className="logo-section textcenter">
              <div>
                <img src={bhrigu_logo} alt="Bhrigu Logo" />
              </div>
              {/* <div className="logo">
                <img src={bhrigu} alt="Bhrigu Logo" />
              </div>
              <div className="slider">
                <img src={lineage} alt="lineage1" />
                <img src={lineage2} alt="lineage2" />
                <img src={lineage3} alt="lineage3" />
                <img src={lineage4} alt="lineage4" />
                <img src={lineage5} alt="lineage5" />
                <img src={lineage6} alt="lineage6" />
              </div> */}
            </div>
          </div>

          {/* Register Form */}
          <div className="col-md-6 offset-md-2 product">
            {loading && <Loader />}
            <div className="row registedlogin responsive">
              <div className="col-md-12">
                <h2>Register</h2>
                <form onSubmit={handleSubmit} noValidate>
                  <div>
                    {/* Full Name */}
                    {/* <div className="responsivefulldiv">
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Name"
                        disabled={otpVerified} />
                      {errors.name && (
                        <span className="error">{errors.name}</span>
                      )}
                    </div> */}
                    <div className="row">
                      <div className="col-md-6">
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          placeholder="Name"
                          disabled={otpVerified}
                        />
                        {errors.name && (
                          <span className="error">{errors.name}</span>
                        )}
                      </div>
                      <div className="col-md-6">
                        <select
                          name="gender"
                          value={formData.gender}
                          onChange={handleChange}
                        >
                          <option value="">Select Gender</option>
                          {gender_options.map((status) => (
                            <option key={status.value} value={status.value}>
                              {status.label}
                            </option>
                          ))}
                        </select>
                        {errors.gender && (
                          <span className="error">{errors.gender}</span>
                        )}
                      </div>
                    </div>

                    {/* Father's Name */}
                    <div className="responsivefulldiv">
                      <input
                        type="text"
                        name="father_name"
                        value={formData.father_name}
                        onChange={handleChange}
                        placeholder="Father's Name"
                      />
                      {errors.father_name && (
                        <span className="error">{errors.father_name}</span>
                      )}
                    </div>

                    {/* DOB & Marital Status */}
                    <div className="row">
                      <div className="col-md-6">
                        <input
                          type="date"
                          name="dob"
                          value={formData.dob}
                          onChange={handleChange}
                          placeholder="DOB"
                          disabled={otpVerified}
                          required
                        />

                        {errors.dob && (
                          <span className="error">{errors.dob}</span>
                        )}
                      </div>
                      <div className="col-md-6">
                        <select
                          name="marital_status"
                          value={formData.marital_status}
                          onChange={handleChange}
                        >
                          <option value="">Select Marital Status</option>
                          {marital_statusOptions.map((status) => (
                            <option key={status.value} value={status.value}>
                              {status.label}
                            </option>
                          ))}
                        </select>
                        {errors.maritalStatus && (
                          <span className="error">{errors.maritalStatus}</span>
                        )}
                      </div>
                    </div>

                    {/* Address */}
                    <div className="responsivefulldiv">
                      <input
                        type="text"
                        name="address_line_1"
                        value={formData.address_line_1}
                        onChange={handleChange}
                        placeholder="Address Line 1"
                      />
                      {errors.address_line_1 && (
                        <span className="error">{errors.address_line_1}</span>
                      )}
                    </div>
                    <div className="responsivefulldiv">
                      <input
                        type="text"
                        name="address_line_2"
                        value={formData.address_line_2}
                        onChange={handleChange}
                        placeholder="Address Line 2"
                      />
                    </div>

                    {/* State, Country, Pincode */}
                    <div className="row">
                      <div className="col-md-4">
                        <select
                          name="country"
                          value={formData.country?.country || ""}
                          // onChange={handleChange}
                          onChange={(e) => {
                            const selected = countryList.find(
                              (c) => c.country === e.target.value
                            );

                            setFormData((prev) => ({
                              ...prev,
                              country: selected || null,
                              state: "",
                              aadhaar_no:
                                selected?.PK === 26 ? "" : "000000000000", // India vs Others
                            }));
                          }}
                        >
                          <option value="">Select Country</option>
                          {countryList.map((country) => (
                            <option key={country.PK} value={country.country}>
                              {country.country}
                            </option>
                          ))}
                        </select>
                        {errors.country && (
                          <span className="error">{errors.country}</span>
                        )}
                      </div>

                      <div className="col-md-4">
                        {formData.country?.PK === 26 ? (
                          <select
                            name="state"
                            value={formData.state}
                            onChange={handleChange}
                          >
                            <option value="">Select State</option>
                            {stateList.map((state) => (
                              <option key={state.PK} value={state.State}>
                                {state.State}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <input
                            type="text"
                            name="state"
                            value={formData.state}
                            onChange={handleChange}
                            placeholder="Enter State/Province"
                          />
                        )}
                        {errors.state && (
                          <span className="error">{errors.state}</span>
                        )}
                      </div>
                      <div className="col-md-4">
                        <input
                          type="text"
                          name="pincode"
                          value={formData.pincode}
                          onChange={handleChange}
                          placeholder="Pincode"
                        />
                        {errors.pincode && (
                          <span className="error">{errors.pincode}</span>
                        )}
                      </div>
                    </div>

                    {/* Mobile */}
                    <div className="responsivefulldiv">
                      <input
                        type="tel"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                        placeholder="Mobile"
                      />
                      {errors.mobile && (
                        <span className="error">{errors.mobile}</span>
                      )}
                    </div>

                    {/* Email */}
                    <div className="responsivefulldiv">
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="E-Mail Address"
                      />
                      {errors.email && (
                        <span className="error">{errors.email}</span>
                      )}
                    </div>

                    {/* Aadhar */}
                    <div className="responsivefulldiv">
                      <input
                        type="text"
                        name="aadhaar_no"
                        value={formData.aadhaar_no}
                        onChange={handleChange}
                        placeholder="Aadhaar Number"
                        disabled={formData.country?.PK !== 26} // 26 = India
                      />
                      {errors.aadhaar_no && (
                        <span className="error">{errors.aadhaar_no}</span>
                      )}
                    </div>
                    <div className="row aadharotp" >
                      {/* <div className="col-md-8">
                        <input
                          type="text"
                          name="aadhaar_no"
                          value={formData.aadhaar_no}
                          onChange={handleChange}
                          placeholder="Aadhar Number"
                        // disabled={otpVerified}
                        // disabled={true}  // ✅ Disable Aadhar input always
                        />
                        {errors.aadhaar_no && (
                          <span className="error">{errors.aadhaar_no}</span>
                        )}
                      </div> */}
                      {/* <div className="col-md-3 optrow">
                        {!otpVerified && (
                          <button
                            type="button"
                            onClick={handleSendOtp}
                            className="btn btn-primary"
                            disabled={otpVerified}   // ✅ disable Send/Resend OTP after verification
                            // disabled={true}
                            style={{
                              cursor: "not-allowed",
                              opacity: 0.65, // Bootstrap default for disabled
                              pointerEvents: "none"
                            }}
                          >
                            {otpSent ? "Resend OTP" : "Send OTP"}
                          </button>
                            )}
                      </div> */}
                    </div>
                    {/* OTP Input */}
                    {/* {otpSent && !otpVerified && (
                      <div className="row aadharotp">
                        <div className="col-md-8">
                          <input
                            type="text"
                            name="verificationcode"
                            value={otp}
                            placeholder="Enter OTP"
                            onChange={(e) => setOtp(e.target.value)}
                          />
                        </div>
                        <div className="col-md-3">
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleVerifyOtp}
                          >
                            Verify
                          </button>
                        </div>
                      </div>
                    )} */}
                    {/* Gotra & Kuldevi */}
                    {/* {otpVerified && ( */}
                    < div className="row aadharotp">
                      <div className="col-md-3">
                        <input
                          type="text"
                          name="gotra"
                          value={formData.gotra}
                          onChange={handleChange}
                          placeholder="Gotra" />
                        {errors.gotra && <span className="error">{errors.gotra}</span>}
                      </div>
                      <div className="col-md-6 threequater">
                        <input
                          type="text"
                          name="kuldevi"
                          value={formData.kuldevi}
                          onChange={handleChange}
                          placeholder="Kuldevi" />
                        {errors.kuldevi && <span className="error">{errors.kuldevi}</span>}
                      </div>
                    </div>
                    {/* )} */}
                    {/* Submit */}
                    <div
                      className="textright mt-4 row aadharotp"
                      style={{ width: "100%", justifyContent: "end" }}
                    >
                      <div className="col-md-12 submitbtndiv">
                        <span
                          style={{
                            color: "white",
                            fontSize: "12px",
                            paddingRight: "10px",
                          }}
                        >
                          Your registration is subject to admin approval.
                        </span>
                        <input
                          type="submit"
                          value="Submit"
                        // disabled={!otpVerified
                        // || !formData.gotra || !formData.kuldevi
                        // }
                        // style={{
                        //   cursor:
                        //     !otpVerified
                        //       //  || !formData.gotra || !formData.kuldevi
                        //       ? "not-allowed"
                        //       : "pointer",
                        //   opacity:
                        //     !otpVerified
                        //       // || !formData.gotra || !formData.kuldevi 
                        //       ? 0.65 : 1,
                        //   pointerEvents:
                        //     !otpVerified
                        //       // || !formData.gotra || !formData.kuldevi
                        //       ? "none"
                        //       : "auto",
                        //   transition: "opacity 0.3s ease", // optional for smooth effect
                        // }}
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {/* <div className="imageUploadSection">
            <div className="imgFigure"></div>
            <input type="file" name="profileimg" id="profileimg"/>
          </div>  */}
        </div>
      </div>
      <div className="container">
        <div className="counterdiv">
          <span className="counterspanlabel">
            {" "}
            <span className="counterLabel"> YOU'R VISITOR NO. </span>
            <span className="countername" style={{ paddingRight: "20px" }}>
              {visitorCount}
            </span>
          </span>
          <span className="counterspanlabel">
            {" "}
            <span className="counterLabel">REGISTERED MEMBERS </span>
            <span className="countername">{registeredMembers}</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
